module.exports = __webpack_public_path__ + "static/media/icon-employer.fea5867a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/WizardInvitee/parts/images/icon-employer.svg
// module id = 561
// module chunks = 0